import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, ShieldCheckIcon, LockIcon, ZapIcon, SmartphoneIcon, FlameIcon, GiftIcon, ArrowRightIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { bonuses, idealFor, offerIncludes } from '../data/system';
const trust = [{
  icon: LockIcon,
  label: 'Pagamento sicuro'
}, {
  icon: ZapIcon,
  label: "Accesso immediato dopo l'acquisto"
}, {
  icon: SmartphoneIcon,
  label: 'Consultabile da Android e iOS'
}, {
  icon: ShieldCheckIcon,
  label: 'Garanzia di 7 giorni'
}];
export function Pricing() {
  return <section id="pricing" aria-label="Prezzo" className="scroll-mt-12 bg-obsidian text-white" data-id="element-191" data-mp="25s7ryxzhcdw6">
      <div className="mx-auto max-w-5xl px-5 py-16 lg:py-24" style={{
      paddingTop: "17px",
      paddingBottom: "21px"
    }} data-id="element-192" data-mp="20t4pnlavwlrw">
        <div className="mx-auto max-w-xl text-center" data-id="element-193" data-mp="3h6v5fpbd8yhd">
          <p className="inline-flex items-center gap-1.5 rounded-full border border-ember/40 bg-ember/10 px-4 py-1.5 text-xs font-bold uppercase tracking-wider text-ember" data-id="element-194" data-mp="3h9hddq265g04">
            <FlameIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-195" data-mp="3vynj6hf3w1bz" /> Offerta di lancio — 27 €
          </p>
          
          <p className="mt-4 text-[15px] leading-relaxed text-white/65" data-id="element-196" data-mp="4rb1806efjv0">
            Il prezzo di riferimento è 54 €. L'offerta di lancio è disponibile alle condizioni indicate in
            questa pagina. Il prezzo potrà tornare a 54 € al termine della promozione.
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-40px'
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="mt-10 overflow-hidden rounded-3xl border border-white/10 bg-navy shadow-[0_40px_80px_-40px_rgba(20,125,255,0.45)] lg:grid lg:grid-cols-[1fr_1.05fr]" data-id="element-197" data-mp="3dasbnfa37jrb">
          <div className="border-b border-white/10 p-6 sm:p-8 lg:border-b-0 lg:border-r" style={{
          paddingTop: "0px"
        }} data-id="element-198" data-mp="2uhy6fd29n60a">
            
            <h3 className="mt-6 font-display text-3xl font-extrabold uppercase leading-none" data-id="element-199" data-mp="2rguz3btv5sco">
              Il Sistema Triathlon Full Distance™
            </h3>
            <p className="mt-6 text-xs font-bold uppercase tracking-[0.22em] text-aqua" data-id="element-200" data-mp="2mh8lv2e1cc3v">Ideale per</p>
            <ul className="mt-3 space-y-2.5" data-id="element-201" data-mp="315wfh34bmbr6">
              {idealFor.map(item => <li key={item} className="flex items-start gap-2.5 text-sm leading-snug text-white/75" data-id="element-202" data-mp="2w8mhgz2v8rrq">
                  <ArrowRightIcon className="mt-0.5 h-4 w-4 shrink-0 text-electric" aria-hidden="true" data-id="element-203" data-mp="28j1wkan5jkft" />
                  {item}
                </li>)}
            </ul>
          </div>

          <div className="p-6 sm:p-8" data-id="element-204" data-mp="2igpvlcrsje3s">
            <div className="flex items-end gap-3" data-id="element-205" data-mp="2ihhpmj5qp3ry">
              <span className="font-display text-[84px] font-extrabold leading-[0.8]" data-id="element-206" data-mp="2dgka6ec46nu5">27 €</span>
              <span className="pb-1 text-xl font-medium text-white/35 line-through" data-id="element-207" data-mp="3tutxd54me6je">54 €</span>
            </div>
            <p className="mt-4 text-xs font-semibold text-white/70" data-id="element-208" data-mp="3ox1szbmsgryb">Pagamento unico · Accesso a vita ai materiali acquistati</p>
            <p className="mt-1 text-[11px] text-white/45" data-id="element-209" data-mp="8sqf0suial5">
              Il pagamento sarà elaborato in base alle modalità e alla valuta mostrate nella pagina di checkout.
            </p>

            <p className="mt-7 text-xs font-bold uppercase tracking-[0.22em] text-white/50" data-id="element-210" data-mp="3ngel3ob8iu2c">
              Il tuo sistema completo include
            </p>
            <ul className="mt-3 grid gap-x-4 gap-y-2 sm:grid-cols-2" data-id="element-211" data-mp="j0vdouzzsp4d">
              {offerIncludes.map(f => <li key={f} className="flex items-start gap-2 text-sm leading-snug text-white/85" data-id="element-212" data-mp="nzyeu4cuqb72">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-perf" strokeWidth={3} aria-hidden="true" data-id="element-213" data-mp="a8jk509l0lk6" />
                  {f}
                </li>)}
            </ul>

            <p className="mt-7 text-xs font-bold uppercase tracking-[0.22em] text-white/50" data-id="element-214" data-mp="e8btvgapoxr4">
              In più, 4 bonus inclusi
            </p>
            <ul className="mt-3 divide-y divide-white/10 border-y border-white/10" data-id="element-215" data-mp="16qzfqxxj8gt9">
              {bonuses.map(b => <li key={b.n} className="flex items-center justify-between gap-3 py-2.5 text-sm" data-id="element-216" data-mp="3f7sc3zu40bvu">
                  <span className="flex min-w-0 items-center gap-2 text-white/85" data-id="element-217" data-mp="3a85yvqea6vn1">
                    <GiftIcon className="h-4 w-4 shrink-0 text-electric" aria-hidden="true" data-id="element-218" data-mp="3592r3y6x2bbd" />
                    <span className="truncate" data-id="element-219" data-mp="3180qpe19jt7t">{b.title}</span>
                  </span>
                  <span className="whitespace-nowrap text-xs" data-id="element-220" data-mp="31a3nqi0u2mm1">
                    <span className="text-white/35 line-through" data-id="element-221" data-mp="1s44phg06atq">{b.price}</span>{' '}
                    <span className="font-bold text-perf" data-id="element-222" data-mp="3t087cegrr5m7">{b.included}</span>
                  </span>
                </li>)}
            </ul>

            <div className="mt-5 rounded-xl border border-perf/25 bg-perf/10 px-4 py-3 text-white" data-id="element-223" data-mp="3o641xzn5j5n8">
              <p className="flex items-center gap-2 text-sm font-semibold" data-id="element-224" data-mp="3k4si6aqylemy">
                <ShieldCheckIcon className="h-5 w-5 shrink-0 text-perf" aria-hidden="true" data-id="element-225" data-mp="kkokpyalslg4" />
                Garanzia soddisfatti o rimborsati di 7 giorni
              </p>
              <p className="mt-1.5 text-xs leading-relaxed text-white/65" data-id="element-226" data-mp="1yg6o1fdsuwxm">
                Se entro i primi 7 giorni decidi che il sistema non è adatto alle tue esigenze, puoi richiedere
                il rimborso secondo le condizioni della garanzia.
              </p>
            </div>

            <div className="mt-6" data-id="element-227" data-mp="2cf6b4ilnz3ro">
              <CTAButton className="max-w-none" data-id="element-228" data-mp="2cghbs9jtbvek">Inizia ora la tua preparazione</CTAButton>
            </div>
            <p className="mt-3 text-center text-xs font-semibold text-perf" data-id="element-229" data-mp="2hdr2rtmuof4i">
              Risparmi 27 € rispetto al prezzo di riferimento · Offerta di lancio
            </p>

            <ul className="mt-5 grid grid-cols-2 gap-x-4 gap-y-2 text-xs text-white/55" data-id="element-230" data-mp="2r53ricdcqp6b">
              {trust.map(({
              icon: Icon,
              label
            }) => <li key={label} className="inline-flex items-start gap-1.5" data-id="element-231" data-mp="304qvn5xgu932">
                  <Icon className="h-4 w-4 shrink-0 text-aqua" aria-hidden="true" data-id="element-232" data-mp="302nvvu6ih1l5" />
                  {label}
                </li>)}
            </ul>
          </div>
        </motion.div>
      </div>
    </section>;
}